import { ComponentType } from 'react'

import CheckCircleIcon from '~/components/Icons/svgs/CheckCircleIcon'
import GlobeIcon from '~/components/Icons/svgs/GlobeIcon'
import HomGraduationCapIcon from '~/components/Icons/svgs/HomGraduationCapIcon'
import UsersIcon from '~/components/Icons/svgs/UsersIcon'
import { CurriculumCountryCodes } from '~/curriculum/constants/curriculum.const'
import { AppLanguage } from '~/types/locale'

export const testimonialItems = [
  {
    id: 1,
    image: {
      srcKey: 'landing/start/testimonials/testimonial-lisa.webp',
      alt: 'testimonials.review1.alt',
    },
    author: 'testimonials.review1.name',
    subinfo: 'testimonials.review1.subinfo',
    text: 'testimonials.review1.text',
  },
  {
    id: 2,
    image: {
      srcKey: 'landing/start/testimonials/testimonial-anders.webp',
      alt: 'testimonials.review2.alt',
    },
    author: 'testimonials.review2.name',
    subinfo: 'testimonials.review2.subinfo',
    text: 'testimonials.review2.text',
  },
  {
    id: 3,
    image: {
      srcKey: 'landing/start/testimonials/testimonial-sienna-purple.png',
      alt: 'testimonials.review3.alt',
    },
    author: 'testimonials.review3.name',
    subinfo: 'testimonials.review3.subinfo',
    text: 'testimonials.review3.text',
  },
  {
    id: 4,
    image: {
      srcKey: 'landing/start/testimonials/testimonial-morten.webp',
      alt: 'testimonials.review4.alt',
    },
    author: 'testimonials.review4.name',
    subinfo: 'testimonials.review4.subinfo',
    text: 'testimonials.review4.text',
  },
  {
    id: 5,
    image: {
      srcKey: 'landing/start/testimonials/testimonial-catharina.webp',
      alt: 'testimonials.review5.alt',
    },
    author: 'testimonials.review5.name',
    subinfo: 'testimonials.review5.subinfo',
    text: 'testimonials.review5.text',
  },
]

export const faqData = [
  {
    questionKey: 'question1.text',
    answerKey: 'question1.answer',
  },
  {
    questionKey: 'question2.text',
    answerKey: 'question2.answer',
  },
  {
    questionKey: 'question3.text',
    answerKey: 'question3.answer',
  },
  {
    questionKey: 'question4.text',
    answerKey: 'question4.answer',
  },
  {
    questionKey: 'question5.text',
    answerKey: 'question5.answer',
  },
]

export const logos = [
  {
    alt: 'tv2',
    srcKey: 'landing/start/logos/2.png',
    width: 25,
    height: 32,
    mobileWidth: 18,
    mobileHeight: 14,
    type: AppLanguage.NO,
    link: 'https://www.tv2.no/video/underholdning/god-morgen-norge/fra-mattetaper-til-mattesuksess/1223855/',
  },
  {
    alt: 'nrk',
    srcKey: 'landing/start/logos/nrk.png',
    width: 68,
    height: 24,
    mobileWidth: 38,
    mobileHeight: 13,
    type: AppLanguage.NO,
    link: 'https://www.nrk.no/norge/privatlaerer-frykter-leksefri-kampanje-vil-fore-til-mobbing-1.12612887',
  },
  {
    alt: 'vg',
    srcKey: 'landing/start/logos/vg.png',
    width: 100,
    height: 20,
    mobileWidth: 58,
    mobileHeight: 18,
    type: AppLanguage.NO,
    link: 'https://www.vg.no/nyheter/innenriks/i/OMPMk/karoline-16-helt-normalt-aa-ha-privatlaerer',
  },
  {
    alt: 'tedx',
    srcKey: 'landing/start/logos/tedx.png',
    width: 68,
    height: 20,
    mobileWidth: 40,
    mobileHeight: 12,
    type: AppLanguage.NO,
    link: 'https://www.youtube.com/watch?v=PraLMm_XAhk',
  },
  {
    alt: 'dnb',
    srcKey: 'landing/start/logos/dnb.png',
    width: 44,
    height: 64,
    mobileWidth: 37,
    mobileHeight: 26,
    type: AppLanguage.NO,
    link: 'https://www.dnb.no/kundeprogram/fordeler/house-of-math',
  },

  {
    alt: 'abc/nyheter',
    srcKey: 'landing/start/logos/abc.png',
    width: 150,
    height: 26,
    mobileWidth: 85,
    mobileHeight: 15,
    type: AppLanguage.NO,
    link: undefined,
  },
  {
    alt: 'aftenposten',
    srcKey: 'landing/start/logos/afterposten.png',
    width: 110,
    height: 30,
    mobileWidth: 62,
    mobileHeight: 18,
    type: AppLanguage.NO,
    link: 'https://www.aftenposten.no/amagasinet/i/y30kmJ/vibeke-faengsrud-vi-er-saa-utrolig-redde-for-at-noen-skal-bli-lei-seg-hvis-vi-stiller-krav',
  },
  {
    alt: 'oslo',
    srcKey: 'landing/start/logos/oslo-logo.png',
    width: 90,
    height: 45,
    mobileWidth: 50,
    mobileHeight: 25,
    type: AppLanguage.NO,
    link: 'https://sagene.osloskolen.no/nyhetsarkiv/sagene-skole-har-et-samarbeid-med-house-of-math/',
  },
  {
    alt: 'LA Weekly',
    srcKey: 'landing/start/logos/la-weekly.png',
    width: 90,
    height: 30,
    mobileWidth: 40,
    mobileHeight: 12,
    type: AppLanguage.EN,
    link: 'https://www.laweekly.com/homework-is-for-students-not-parents/',
  },
  {
    alt: 'citybiz',
    srcKey: 'landing/start/logos/city.png',
    width: 100,
    height: 30,
    mobileWidth: 64,
    mobileHeight: 20,
    type: AppLanguage.EN,
    link: 'https://www.citybiz.co/article/728204/norways-top-math-platform-house-of-math-launches-in-u-s-to-help-students-tackle-math-anxiety/',
  },
  {
    alt: 'tedx',
    srcKey: 'landing/start/logos/tedx.png',
    width: 68,
    height: 30,
    mobileWidth: 40,
    mobileHeight: 12,
    type: AppLanguage.EN,
    link: 'https://www.youtube.com/watch?v=PraLMm_XAhk',
  },
  {
    alt: 'USA Today',
    srcKey: 'landing/start/logos/usa-today.png',
    width: 93,
    height: 30,
    mobileWidth: 40,
    mobileHeight: 12,
    type: AppLanguage.EN,
    link: 'https://www.usatoday.com/story/special/contributor-content/2026/02/12/how-vibeke-faengsrud-is-bringing-house-of-math-to-the-us/88647390007/',
  },
  {
    alt: 'SF Weekly',
    srcKey: 'landing/start/logos/sf-weekly.png',
    width: 100,
    height: 30,
    mobileWidth: 40,
    mobileHeight: 12,
    type: AppLanguage.EN,
    link: 'https://www.sfweekly.com/marketplace/mastering-and-understanding-mathematics-with-house-of-math/article_2acf39da-bb07-42a8-84f5-61ba8614c338.html',
  },
  {
    alt: 'EIN PressWire',
    srcKey: 'landing/start/logos/ein.png',
    width: 128,
    height: 30,
    mobileWidth: 80,
    mobileHeight: 19,
    type: AppLanguage.EN,
    link: 'https://www.einpresswire.com/article/837348773/norway-s-top-math-platform-house-of-math-launches-in-u-s-to-help-students-tackle-math-anxiety',
  },
  {
    alt: 'Authority Magazine',
    srcKey: 'landing/start/logos/authority-magazine.png',
    width: 55,
    height: 55,
    mobileWidth: 40,
    mobileHeight: 12,
    type: AppLanguage.EN,
    link: 'https://medium.com/authority-magazine/female-founders-vibeke-faengsrud-of-house-of-math-on-the-five-things-you-need-to-thrive-and-2370c07438be',
  },
]

export const homWorks = [
  {
    heading: 'chooseYourGrade',
    description: 'chooseYourGradeDescription',
    image: {
      srcKey: 'landing/start/homWorks/avatar.png',
      size: {
        width: 500,
        height: 280,
      },
    },
    pointerColor: 'bg-orchid-dark',
    stepHeaderColor: 'bg-orchid-dark bg-opacity-40',
    hasAiIcon: false,
    videoSrcMp4: null,
    videoSrcWebm: null,
    videoPosterSrc: null,
  },
  {
    heading: 'masteryTrack',
    description: 'masteryTrackDescription',
    image: {
      srcKey: 'landing/start/GroupAi.png',
      size: {
        width: 300,
        height: 300,
      },
    },
    pointerColor: 'bg-pink-deep',
    stepHeaderColor: 'bg-pink-deep bg-opacity-40',
    hasAiIcon: false,
    videoSrcMp4: null,
    videoSrcWebm: null,
    videoPosterSrc: null,
  },
  {
    heading: 'interactiveExercises',
    description: 'interactiveExercisesDescription',
    image: {
      srcKey: 'landing/start/homWorks/cert.png',
      size: {
        width: 250,
        height: 250,
      },
    },
    pointerColor: 'bg-blue-blueberry',
    stepHeaderColor: 'bg-blue-blueberry bg-opacity-40',
    hasAiIcon: false,
    videoSrcMp4: 'landing/start/videos/Activities.mp4',
    videoSrcWebm: 'landing/start/videos/Activities.webm',
    videoPosterSrc: 'landing/start/videos/Activities.png',
    videoSrcMp42: 'landing/start/videos/activities2.mp4',
    videoSrcWebm2: 'landing/start/videos/activities2.webm',
    videoPosterSrc2: 'landing/start/videos/activities2.png',
  },
  {
    heading: 'collectGems',
    description: 'collectGemsDescription',
    image: {
      srcKey: 'landing/start/homWorks/rewards.png',
      size: {
        width: 350,
        height: 350,
      },
    },
    pointerColor: 'bg-orange-fulvous',
    stepHeaderColor: 'bg-orange-fulvous bg-opacity-40',
    hasAiIcon: false,
    videoSrcMp4: null,
    videoSrcWebm: null,
    videoPosterSrc: null,
  },
  {
    heading: 'beAwarded',
    description: 'beAwardedDescription',
    image: {
      srcKey: 'landing/start/homWorks/all-certificates.png',
      size: {
        width: 420,
        height: 260,
      },
    },
    pointerColor: 'bg-gradient-homebase-tilt130',
    stepHeaderColor: 'bg-gradient-homebase-tilt130',
    hasAiIcon: false,
    videoSrcMp4: null,
    videoSrcWebm: null,
    videoPosterSrc: null,
  },
]

export interface IntroItem {
  className?: string
  icon: string
  iconSize?: number
  text: string
  altKey: string
  iconComponent: ComponentType<any>
}

export interface SponsorItem {
  icon: string
  altKey: string
  height: number
  width: number
  className?: string
  bottomText?: string
}

const introItemsNO: IntroItem[] = [
  {
    className: 'min-w-32',
    icon: 'landing/start/hat.svg',
    iconSize: 20,
    text: 'intro.backedbyTeachers',
    altKey: 'imageAlt:icons.houseOfMath',
    iconComponent: HomGraduationCapIcon,
  },
  {
    className: 'min-w-32',
    icon: 'landing/start/check.svg',
    iconSize: 18,
    text: 'intro.curriculum',
    altKey: 'imageAlt:icons.houseOfMath',
    iconComponent: CheckCircleIcon,
  },
  {
    className: 'min-w-32',
    icon: 'landing/start/people.svg',
    iconSize: 20,
    text: 'intro.users',
    altKey: 'imageAlt:icons.houseOfMath',
    iconComponent: UsersIcon,
  },
  {
    className: 'min-w-32',
    icon: 'landing/start/world.svg',
    iconSize: 18,
    text: 'intro.builtInNorway',
    altKey: 'imageAlt:icons.houseOfMath',
    iconComponent: GlobeIcon,
  },
]

const introItemsUS: IntroItem[] = [
  {
    className: 'min-w-36',
    icon: 'landing/start/hat.svg',
    iconSize: 20,
    text: 'intro.backedbyTeachers',
    altKey: 'imageAlt:icons.houseOfMath',
    iconComponent: HomGraduationCapIcon,
  },
  {
    className: 'min-w-36',
    icon: 'landing/start/people.svg',
    iconSize: 20,
    text: 'intro.users',
    altKey: 'imageAlt:icons.houseOfMath',
    iconComponent: UsersIcon,
  },
  {
    className: 'min-w-36',
    icon: 'landing/start/icon-park-solid_notebook.svg',
    iconSize: 18,
    text: 'intro.usCurriculum',
    altKey: 'imageAlt:icons.houseOfMath',
    iconComponent: GlobeIcon,
  },
  {
    className: 'min-w-36',
    icon: 'landing/start/check.svg',
    iconSize: 18,
    text: 'intro.cancelAnytime',
    altKey: 'imageAlt:icons.houseOfMath',
    iconComponent: CheckCircleIcon,
  },
]

export const getIntroItems = (curriculumCountryCode: CurriculumCountryCodes | string): IntroItem[] => {
  switch (curriculumCountryCode) {
    case CurriculumCountryCodes.NORWAY:
      return introItemsNO
    case CurriculumCountryCodes.USA:
    default:
      return introItemsUS
  }
}

const sponsersListNO = [
  {
    icon: 'donation/sponsors/accenture_new.png',
    altKey: 'imageAlt:icons.accenture',
    height: 24,
    width: 80,
    className: '-mt-2.5',
  },
  {
    icon: 'partners/dnb-logo.svg',
    bottomText: 'intro.dnb',
    altKey: 'imageAlt:icons.dnb',
    height: 24,
    width: 36,
  },
  {
    icon: 'partners/crayon.svg',
    bottomText: 'intro.crayon',
    altKey: 'imageAlt:icons.crayon',
    height: 24,
    width: 80,
  },
  {
    icon: 'partners/tine-v2.png',
    bottomText: 'intro.tine',
    altKey: 'imageAlt:icons.tine',
    height: 25,
    width: 38,
  },
  {
    icon: 'partners/knowit-v2.svg',
    bottomText: 'intro.knowit',
    altKey: 'imageAlt:icons.knowit',
    height: 24,
    width: 60,
  },
]

const sponsersListUS: SponsorItem[] = [
  {
    icon: 'partners/amazon.png',
    bottomText: 'intro.amazon',
    className: 'mt-3',
    altKey: 'imageAlt:icons.amazon',
    height: 27,
    width: 76,
  },
  {
    icon: 'partners/chick-fil-a.png',
    bottomText: 'intro.chickFilA',
    altKey: 'imageAlt:icons.chickFilA',
    height: 31,
    width: 70,
    className: '-mt-2',
  },
  {
    icon: 'partners/benefit-hub.svg',
    bottomText: 'intro.benefitHub',
    altKey: 'imageAlt:icons.benefitHub',
    height: 24,
    width: 98,
  },
  {
    icon: 'donation/sponsors/accenture_new.png',
    bottomText: 'intro.accenture',
    altKey: 'imageAlt:icons.accenture',
    height: 24,
    width: 80,
    className: '-mt-2',
  },
  {
    icon: 'partners/crayon.svg',
    bottomText: 'intro.crayon',
    altKey: 'imageAlt:icons.crayon',
    height: 24,
    width: 80,
  },
  {
    icon: 'partners/knowit-v2.svg',
    bottomText: 'intro.knowit',
    altKey: 'imageAlt:icons.knowit',
    height: 24,
    width: 60,
  },
  {
    icon: 'partners/perks.png',
    bottomText: 'intro.perksAtWork',
    altKey: 'imageAlt:icons.perksAtWork',
    height: 26,
    width: 106,
  },
  { icon: 'partners/acg.png', altKey: 'imageAlt:icons.acg', height: 26, width: 47 },
]

export const getSponsers = (countryCode?: string): SponsorItem[] => {
  if (countryCode === 'NO') {
    return sponsersListNO
  }
  return sponsersListUS
}

export const startSections = {
  intro: { nr: 1, name: 'Where everyone can master math' },
  meetMind: { nr: 2, name: 'Meet MIND, Your Personal Math AI' },
  mathMotion: { nr: 3, name: 'What Makes House of Math Unique' },
  powerUpDragon: { nr: 4, name: 'Power Up Your Dragon' },
  testimonials: { nr: 5, name: 'Real stories. Real results.' },
  howHomWorks: { nr: 6, name: 'How House of Math Works' },
  mathAdventure: { nr: 7, name: 'Ready to Start Your Math Adventure?' },
  faq: { nr: 8, name: 'FAQ' },
}
export const landing = {
  intro: { nr: 1, name: "Math gaps don't fix themselves" },
  video: { nr: 10, name: 'Watch our introduction video' },
  meetMind: { nr: 2, name: 'Meet MIND, Your Personal Math AI' },
  testimonials: { nr: 3, name: 'Real stories. Real results.' },
  mathRecipe: { nr: 4, name: 'Math is not a code to crack' },
  baseBuildBurn: { nr: 5, name: 'The Base Build Burn Method Leaves No Student Behind' },
  atomicMath: { nr: 6, name: 'The Base Build Burn Method Leaves No Student Behind' },
  faq: { nr: 7, name: 'FAQ' },
  knowledgeGaps: { nr: 8, name: 'Your knowledge gaps? ready to map and fill' },
  pricing: { nr: 9, name: 'Pricing' },
}

export const landingV2 = {
  intro: { nr: 1, name: 'What takes 2 weeks in school takes 2 hours here' },
  whyGetStuck: { nr: 2, name: 'Why your child gets stuck, even when they try' },
  nothingWorkedYet: { nr: 3, name: 'Why nothing has worked (yet)' },
  usersAnswer: { nr: 4, name: '93% of our users answer that we helped them understand and master math' },
  yourNeeds: { nr: 5, name: 'We understand your child’s needs' },
  smallGaps: { nr: 6, name: 'Small math gaps become big confidence problems' },
  foundWish: { nr: 7, name: 'I wish we had found this earlier.' },
  testimonials: { nr: 8, name: 'Testimonials' },
  findOut: { nr: 9, name: 'I wish we had found this earlier.' },
  faq: { nr: 10, name: 'FAQ' },
  stillQuestions: { nr: 11, name: 'Still have questions? Let the results speak.' },
}
